import gql from 'fraql'
const courierQueries = {
  CHECK_COURIER_POSITION: gql`
  mutation checkCourierPosition ($idOrder: Int!, $position: JSON!) {
    jwtCheckCourierPosition(input: {idOrder: $idOrder, position: $position}) {
      boolean
    }
  }`
}

export {courierQueries}



// WEBPACK FOOTER //
// ./src/graphql/couriers.js